<script type="text/javascript">
import browers from '../../../plugins/browser.js'
import axios from 'axios'
var isApp = browers().isApp
// App.vue中的ref引用
var refs

// 根据Key从cookie中获取相应值
function getCookie(name) {
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  var arr = document.cookie.match(reg)
  if (arr) {
    return name == 'Authorization' ? decodeURIComponent(arr[2]) : arr[2]
  } else {
    return null
  }
}

// 根据Key从localStorage中获取相应值
function getLocalStorage(name) {
  return localStorage.getItem(name)
}
// 获取token
function getToken() {
  return getLocalStorage("token")
}
// 获取用户信息
function getUserInfo() {
  var info = getLocalStorage("user")
  return info ? JSON.parse(info) : {}
}
// 获取工地id
function getSiteId() {
  return getLocalStorage("site-id")
}

// 跳转url
function goUrl(root, url) {
  if(isApp){
    Android.navigationTo("/"+url);
  }else{
    location.assign(root + url);
  }
}
function goOpenTab(root, url) {
  window.open(root + url)
}
// 返回
function goBack() {
  if(isApp){
    Android.goBack();
  }else{
    history.go(-1);//返回上一页并刷新
  }
}

// 设置rem
function setPhoneRem() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  var remSize
  // 判断是否锤子坚果Pro2手机并在在微信浏览器
  if (
    ua.indexOf('os105') > -1 &&
    ua.match(/MicroMessenger/i) == 'micromessenger' &&
    window.screen.width == 432
  ) {
    remSize = (window.screen.width / 37.5 / 3) * 4 + 'px'
  } else {
    remSize = window.screen.width / 37.5 + 'px'
  }
  return remSize
}

// 获取首页url
function getIndexPage() {
  if (location.host.indexOf('test') != -1) {
    return 'http://m.test.jiehun.com.cn'
  } else if (location.host.indexOf('beta') != -1) {
    return 'http://m-beta.jiehun.com.cn'
  } else {
    return 'https://m.jiehun.com.cn'
  }
}
// h5登录
function h5Login(u) {
  if (location.host.indexOf('test') != -1) {
    location.href = '//m.test.jiehun.com.cn/login?u=' + u
  } else if (location.host.indexOf('beta') != -1) {
    location.href = '//m-beta.jiehun.com.cn/login?u=' + u
  } else {
    location.href = '//m.jiehun.com.cn/login?u=' + u
  }
}

// 获取文件接口地址
function getBaseUrlDomainForFile() {
  var urlDomain = process.env.VUE_APP_URL + '/file/'
  return urlDomain
}
// workorder 文件上传
function getParkUrlUploadDomain(){
    var urlDomain = process.env.VUE_APP_PARK_UPLOAD
    return urlDomain
}
// 获取公共地址域名
function getBaseUrlDomain() {
  var urlDomain = process.env.VUE_APP_URL
  return urlDomain
}

// 获取分享地址域名
function getShareUrlDomain() {
  // var urlDomain = ''
  // // TODO 现网环境删除
  // if (DEV_MODE) {
  //   urlDomain = 'http://192.168.0.156:8080/'
  // } else {
  //   urlDomain = '//fun.jiehun.com.cn/luckyday/'
  // }
  // return urlDomain
  return `${document.domain}/`
}

/* 判断手机是否为IPHONEX */
function setIPhoneX() {
  var ret =
    /iphone/gi.test(navigator.userAgent) &&
    screen.height == 812 &&
    screen.width == 375
  this.isIPhoneX = ret
}

/**
 * 粗略判断是否是合法的 APP version
 * @param {String} version APP 版本号 e.g. '6.20.0'
 * @return {Boolean} 返回布尔值
 */
function isValidVersion(version) {
  return /^\d+\.\d+\.\d+$/.test(version)
}

/**
 * 将字符串形式的 APP 版本号，转换成整数形式，便于版本号比较
 * e.g. '6.20.0' -> 60200
 * @param {String} version 字符串形式的版本号
 * @return {Number} 转换成整数形式返回
 */
function getAppVersion(version) {
  const appVersion = version.split('.').map(item => +item)
  return appVersion[0] * 10000 + appVersion[1] * 100 + appVersion[2]
}

/**
 * 将当前的 APP 版本号和指定的 APP 版本号比较，返回一些比较信息
 * @param  {String}   designationVersion 指定的 APP 版本，e.g. '6.20.0'
 * @return {Object}   isApp: 是否是在 APP 中   isGreater: 当前 APP 版本是否大于 designationVersion（指定的 APP 版本）
 */
function compareAppVersion(designationVersion) {
  var that = this
  // 参数校验，如果参数不是合法的 APP 版本号
  if (!that.isValidVersion(designationVersion)) {
    throw new Error('参数不合法，请输入正确的 APP 版本号')
  }
  const currentVersion = that.getCookie('app-version')
  if (!currentVersion) return { isApp: false }
  const currentAppVersion = that.getAppVersion(currentVersion)
  const designationAppVersion = that.getAppVersion(designationVersion)
  return {
    isApp: true,
    isGreater: currentAppVersion >= designationAppVersion
  }
}

// const DEV_MODE = true // 开发模式
const DEV_MODE = false // 正式发布
var isIPhoneX = false

function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURI(r[2])
  }
  return null
}

// 设置当前Cookie
function setCookie(name, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    name +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}

//判断是否是微信浏览器的函数
function isWeiXin() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

// 数组转换为，分隔的字符串
function listToString(list) {
  var r = "";
  for (let index = 0; index < list.length; index++) {
    let num = list[index];
    if (index + 1 == list.length) {
      r += num;
    } else {
      r += num + ",";
    }
  }
  return r;
}

// 获取当前的日期时间 格式“yyyy-MM-dd HH:MM:SS”
function getNowFormatDate () {
  var date = new Date();
  var seperator1 = "-";
  var seperator2 = ":";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate =
    date.getFullYear() +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    date.getHours() +
    seperator2 +
    date.getMinutes() +
    seperator2 +
    date.getSeconds();
  return currentdate;
}

/**
 * 请求拦截
 */
axios.interceptors.request.use(config => {
  config.headers['token'] = getToken() // 请求头带上token
  // config.headers['site-id'] = getSiteId()// 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

export default {
  refs,
  setPhoneRem,
  getCookie,
  getLocalStorage,
  getToken,
  getUserInfo,
  getSiteId,
  goUrl,
  goOpenTab,
  goBack,
  h5Login,
  getBaseUrlDomainForFile,
  getBaseUrlDomain,
  getShareUrlDomain,
  setIPhoneX,
  getIndexPage,
  getUrlParam,
  setCookie,
  isWeiXin,

  isValidVersion,
  getAppVersion,
  compareAppVersion,
  listToString,
  getNowFormatDate,
  getParkUrlUploadDomain,
  DEV_MODE,
  isIPhoneX
}
</script>
